module.exports = __webpack_public_path__ + "static/img/bg-around-foreign-affairs-map.e9e0030.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-around-foreign-affairs-map.jpg
// module id = JZ7z
// module chunks = 1